<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.4246 6.57538C25.5251 10.6759 25.5251 17.3241 21.4246 21.4246C17.3241 25.5251 10.6759 25.5251 6.57538 21.4246C2.47487 17.3241 2.47487 10.6759 6.57538 6.57538C10.6759 2.47487 17.3241 2.47487 21.4246 6.57538"
      :stroke="clr ? clr : '#500FE9'"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.7327 9.52033C16.7212 8.67566 15.4203 8.16699 13.9993 8.16699C10.7782 8.16699 8.16602 10.7792 8.16602 14.0003C8.16602 17.2215 10.7782 19.8337 13.9993 19.8337C17.2205 19.8337 19.8327 17.2215 19.8327 14.0003H14.7285"
      :stroke="clr ? clr : '#500FE9'"
      y
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
